var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlgosharelogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 20,
    viewBox: "0 0 41 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.105%",
    y1: "60.763%",
    x2: "104.038%",
    y2: "37.405%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "16.29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "29.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "39.95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA6B3",
    offset: "53.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D76A5",
    offset: "72.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "94.71%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9.991%",
    y1: "30.297%",
    x2: "80.11%",
    y2: "63.121%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110543",
    stopOpacity: 0.769,
    offset: "23.08%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20094A",
    stopOpacity: 0.49,
    offset: "51.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381156",
    stopOpacity: 0.186,
    offset: "81.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B175F",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-6.506%",
    y1: "62.646%",
    x2: "100.182%",
    y2: "34.678%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "16.29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "29.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "39.95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA6B3",
    offset: "53.63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D76A5",
    offset: "71.42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "93.03%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.181%",
    y1: "49.269%",
    x2: "100.39%",
    y2: "49.269%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0340",
    offset: ".124%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#074F72",
    offset: "16.29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#038898",
    offset: "29.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ACAF",
    offset: "39.95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9B8",
    offset: "45.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA6B3",
    offset: "53.93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D76A5",
    offset: "72.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B63793",
    offset: "94.71%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.963 10.976a5.946 5.946 0 0 0-2.455-1.766c-.947-.361-2.152-.717-3.63-1.064-1.36-.3-2.356-.606-2.991-.907-.635-.301-.953-.758-.953-1.365 0-.537.174-.948.521-1.239.347-.29.853-.436 1.523-.436.853 0 1.562.225 2.128.682.565.456.927 1.078 1.086 1.87h5.53c-.367-2.026-1.284-3.656-2.748-4.89A7.277 7.277 0 0 0 33.425.477l.02-.016h-.005a9.78 9.78 0 0 0-1.88-.39c-.025-.006-.055-.006-.08-.01a12.973 12.973 0 0 0-.456-.036H31A5.046 5.046 0 0 0 30.523 0c-.109 0-.218 0-.327.005h-.074c-2.252 0-4.018.482-5.312 1.44-.263.17-.516.36-.754.572-.045.035-.09.075-.134.11-1.2 1.063-2.376 2.603-3.522 3.772l-.198.2c-.342.352-1.746 1.802-2.917 3.171-1.17 1.37-3.273 3.436-3.273 3.436-1.37 1.29-2.679 2.002-4.27 2.017-2.719.03-4.777-1.977-4.777-4.72 0-2.744 2.202-4.972 4.92-4.972 2.192 0 4.052 1.455 4.687 3.462l5.63-5.207V.005H14.8v1.324A9.735 9.735 0 0 0 9.885.005C4.425.005 0 4.48 0 10.003 0 15.525 4.424 20 9.885 20c1.79 0 3.467-.487 4.915-1.324h.005V20h5.397l.005-6.4.307-.317c.169-.175.338-.351.506-.522l3.145-3.09a5.736 5.736 0 0 0 1.805 1.104c.923.351 2.098.677 3.527.978 1.428.326 2.46.637 3.095.928.635.291.952.773.952 1.45 0 .512-.174.928-.52 1.239-.348.316-.854.471-1.523.471-.968 0-1.756-.22-2.366-.662-.61-.441-.963-1.083-1.052-1.92H22.38c.347 2.166 1.3 3.832 2.867 4.995C26.813 19.418 28.896 20 31.501 20c1.542 0 2.881-.246 4.007-.732 1.131-.492 1.994-1.164 2.594-2.027.6-.863.898-1.851.898-2.97.005-1.384-.342-2.478-1.037-3.295z",
    fill: "url(#a)",
    transform: "translate(.928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.46 4.635c-.347.291-.52.707-.52 1.24 0 .606.317 1.058.952 1.364.634.3 1.631.606 2.99.907 1.474.352 2.684.708 3.631 1.064l-2.921 3.461c-.635-.29-1.667-.602-3.095-.928-1.429-.3-2.604-.627-3.527-.978 0 0-.744-.24-1.805-1.104-1.062-.862.719-3.772.719-3.772l3.576-1.254z",
    fill: "url(#b)",
    transform: "translate(.928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.727 6.747h-5.53c-.164-.793-.526-1.415-1.086-1.871-.566-.452-1.275-.677-2.128-.677-.67 0-1.176.145-1.523.436-.347.291-.52.707-.52 1.24l-3.775 3.791-3.145 3.09c-.099.1-.193.201-.292.301-.174.181-.348.362-.526.537a198.651 198.651 0 0 0-3.16 3.321l.01-.04a9.796 9.796 0 0 1-7.172 3.12C4.424 19.995 0 15.52 0 9.997c0 0 5.947 4.71 9.741 4.72 1.091 0 2.406-.49 3.269-1.173a20.46 20.46 0 0 0 1.027-.868c.01-.005.02-.02.034-.03.343-.341 2.158-2.142 3.214-3.38a70.634 70.634 0 0 1 2.922-3.176l.198-.2c1.15-1.17 2.321-2.71 3.522-3.773.04-.04.089-.075.129-.11.243-.211.496-.402.754-.572C26.104.487 27.87 0 30.122 0h.401c.16 0 .318.01.477.015h.024c.154.005.303.02.457.035a.43.43 0 0 1 .079.01c.65.07 1.275.2 1.88.391h.005l-.015.02c.972.307 1.82.773 2.55 1.385 1.463 1.234 2.375 2.864 2.747 4.89z",
    fill: "url(#c)",
    transform: "translate(.928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.728 13.057c-.07.076-.144.15-.214.226l-.302.316h-.005c.173-.185.347-.366.52-.542z",
    fill: "url(#d)",
    transform: "translate(.928)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgosharelogo);
export default __webpack_public_path__ + "static/media/algosharelogo.5973823cc371cce35a1825d2be78aab5.svg";
export { ForwardRef as ReactComponent };